'use strict';

angular.module('clientDashboardApp').controller("ExportDataModalCtrl",
  function ExportDataModalCtrl($scope, $uibModalInstance, exportOptions) {

    var states = {
      new: 'new',
      pending: 'pending',
      complete: 'complete',
      failed: 'failed'
    };

    $scope.state = states.new;
    $scope.submitted = false;
    $scope.resultsExceedMax = exportOptions.numberOfResults > exportOptions.maxExport;
    $scope.maxExport = exportOptions.maxExport;

    $scope.generate = function () {
      $scope.submitted = true;
      $scope.state = states.pending;
      exportOptions.searchResult.export().then(function (exportResponse) {
        if (exportResponse.data) {
          exportResponse = exportResponse.data;
        }
        if (exportResponse.downloadLink) {
          $scope.state = states.complete;
          $scope.downloadLink = exportResponse.downloadLink;
        } else {
          $scope.state = states.failed;
        }
      });
    };

    $scope.generate();

    $scope.close = function () {
      $uibModalInstance.dismiss('cancel');
    };
  });
